import get from 'lodash/get';
import React, { Fragment } from 'react';
import Icon, { GLYPHS } from '../../../../common/icon';
import { tableColumns } from '../SharedProductList';

const columns = [
  tableColumns.name,
  tableColumns.price,
  tableColumns.supplyPrice,
  tableColumns.shops,
  tableColumns.totalInventory,
  tableColumns.unallocatedInventory,
  tableColumns.lowInventory,
  tableColumns.highInventory,
  {
    ...tableColumns.sku,
    Cell: row => (
      <div data-automation-id={`sku-${row.value}`} className="rt-td__with-icon">
        {!!get(row, 'original.linkedProducts.shopify') && (
          <Fragment>
            <Icon
              data-automation-id={`shopify-icon-${row.value}`}
              className="o-icon--small product-list-shopify-icon"
              glyph={GLYPHS.shopifyLogo}
            />
            {' '}
          </Fragment>
        )}
        {row.value}
      </div>
    ),
  },
  tableColumns.tax,
  tableColumns.category,
  tableColumns.brand,
];

export default columns;
